import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { DynamicField } from '@/components/DynamicField'
import { getCurrentLanguage } from '@/i18next'
import { LANGUAGE_ENUM } from '@/shared'
import { FieldArray, Field as FormikField, getIn } from 'formik'
import cl from 'classnames'

export const CreateForm = memo(() => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()

	const { dictParams, dictValues } = useSelector((state) => ({
		dictParams: state.nomination.dictParams,
		dictValues: state.nomination.dictValues,
	}))

	const fields = useMemo(() => {
		if (dictParams?.data) {
			const grouped = dictParams?.data?.sort((a, b) => a?.groupNum > b?.groupNum ? 1 : -1)?.reduce((acc, currentItem) => {
				if (!acc[currentItem.groupNum]) {
					acc[currentItem.groupNum] = []
				}
				acc[currentItem.groupNum].push(currentItem)
				return acc
			}, {})

			return Object.values(grouped)?.map(i => {
				return i?.sort((a, b) => a?.orderNum > b?.orderNum ? 1 : -1)
			})
		}
	}, [dictParams?.data])

	return (
		<div>
			<FieldArray name={'paramValues'} validateOnChange={true}>
				{({ form: { values, setFieldValue }, ...props }) => {
					return (
						<>
							{fields?.map((field, fieldIdx) => {
								return (
									<div key={fieldIdx} className={cl('flex', 'gap-3')}>
										{
											field.map((i, idx) => {
												let placeholder = {
													[LANGUAGE_ENUM.kz]: i.noteKz,
													[LANGUAGE_ENUM.rus]: i.noteRu,
												}

												let label = {
													[LANGUAGE_ENUM.kz]: i.nameKz,
													[LANGUAGE_ENUM.rus]: i.nameRu,
												}

												let hint = {
													[LANGUAGE_ENUM.kz]: i.infoKz,
													[LANGUAGE_ENUM.rus]: i.infoRu,
												}

												return (
													<div className={cl('mb-2', 'flex-1')} key={`${fieldIdx}-${idx}-${i.code}`}>
														<FormikField name={`paramValues.${i.index}.${i.localParamType}`}>
															{({ field, meta: { touched, error } }) => {
																return (
																	<DynamicField
																		{...field}
																		isRequired={i.paramRequired}
																		placeholder={placeholder[lang] || ''}
																		label={label[lang] || ''}
																		type={i.paramType}
																		hint={hint[lang] || ''}
																		options={dictValues?.data?.[i.dictCode]}
																		error={touched && error}
																	/>
																)
															}}
														</FormikField>
													</div>
												)
											})
										}
									</div>
								)
							})}
						</>
					)
				}}
			</FieldArray>
		</div>
	)
})